export default "__VITE_ASSET__B4LrU2_v__"